(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["arangojs"] = factory();
	else
		root["arangojs"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 9);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __webpack_require__(13);
var messages = {
    0: "Network Error",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Failed",
    413: "Payload Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    421: "Misdirected Request",
    422: "Unprocessable Entity",
    423: "Locked",
    424: "Failed Dependency",
    426: "Upgrade Required",
    428: "Precondition Required",
    429: "Too Many Requests",
    431: "Request Header Fields Too Large",
    444: "Connection Closed Without Response",
    451: "Unavailable For Legal Reasons",
    499: "Client Closed Request",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported",
    506: "Variant Also Negotiates",
    507: "Insufficient Storage",
    508: "Loop Detected",
    510: "Not Extended",
    511: "Network Authentication Required",
    599: "Network Connect Timeout Error"
};
var nativeErrorKeys = ["fileName", "lineNumber", "columnNumber", "stack", "description", "number"];
function isArangoError(err) {
    return Boolean(err && err.isArangoError);
}
exports.isArangoError = isArangoError;

var ArangoError = function (_error_1$default) {
    _inherits(ArangoError, _error_1$default);

    function ArangoError(response) {
        _classCallCheck(this, ArangoError);

        var _this = _possibleConstructorReturn(this, (ArangoError.__proto__ || Object.getPrototypeOf(ArangoError)).call(this));

        _this.name = "ArangoError";
        _this.isArangoError = true;
        _this.response = response;
        _this.statusCode = response.statusCode;
        _this.message = response.body.errorMessage;
        _this.errorNum = response.body.errorNum;
        _this.code = response.body.code;
        var err = new Error(_this.message);
        err.name = _this.name;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = nativeErrorKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                if (err[key]) _this[key] = err[key];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return _this;
    }

    return ArangoError;
}(error_1.default);

exports.ArangoError = ArangoError;

var HttpError = function (_error_1$default2) {
    _inherits(HttpError, _error_1$default2);

    function HttpError(response) {
        _classCallCheck(this, HttpError);

        var _this2 = _possibleConstructorReturn(this, (HttpError.__proto__ || Object.getPrototypeOf(HttpError)).call(this));

        _this2.name = "HttpError";
        _this2.response = response;
        _this2.statusCode = response.statusCode || 500;
        _this2.message = messages[_this2.statusCode] || messages[500];
        _this2.code = _this2.statusCode;
        var err = new Error(_this2.message);
        err.name = _this2.name;
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
            for (var _iterator2 = nativeErrorKeys[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var key = _step2.value;

                if (err[key]) _this2[key] = err[key];
            }
        } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                }
            } finally {
                if (_didIteratorError2) {
                    throw _iteratorError2;
                }
            }
        }

        return _this2;
    }

    return HttpError;
}(error_1.default);

exports.HttpError = HttpError;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var cursor_1 = __webpack_require__(4);
var error_1 = __webpack_require__(0);
var CollectionType;
(function (CollectionType) {
    CollectionType[CollectionType["DOCUMENT_COLLECTION"] = 2] = "DOCUMENT_COLLECTION";
    CollectionType[CollectionType["EDGE_COLLECTION"] = 3] = "EDGE_COLLECTION";
})(CollectionType = exports.CollectionType || (exports.CollectionType = {}));
function isArangoCollection(collection) {
    return Boolean(collection && collection.isArangoCollection);
}
exports.isArangoCollection = isArangoCollection;
exports.DOCUMENT_NOT_FOUND = 1202;
exports.COLLECTION_NOT_FOUND = 1203;

var BaseCollection = function () {
    function BaseCollection(connection, name) {
        _classCallCheck(this, BaseCollection);

        this.isArangoCollection = true;
        this.name = name;
        this._idPrefix = this.name + "/";
        this._connection = connection;
        if (this._connection.arangoMajor >= 3) {
            this.first = undefined;
            this.last = undefined;
            this.createCapConstraint = undefined;
        }
    }

    _createClass(BaseCollection, [{
        key: "_documentPath",
        value: function _documentPath(documentHandle) {
            return "/document/" + this._documentHandle(documentHandle);
        }
    }, {
        key: "_documentHandle",
        value: function _documentHandle(documentHandle) {
            if (typeof documentHandle !== "string") {
                if (documentHandle._id) {
                    return documentHandle._id;
                }
                if (documentHandle._key) {
                    return this._idPrefix + documentHandle._key;
                }
                throw new Error("Document handle must be a document or string");
            }
            if (documentHandle.indexOf("/") === -1) {
                return this._idPrefix + documentHandle;
            }
            return documentHandle;
        }
    }, {
        key: "_indexHandle",
        value: function _indexHandle(indexHandle) {
            if (typeof indexHandle !== "string") {
                if (indexHandle.id) {
                    return indexHandle.id;
                }
                throw new Error("Index handle must be a index or string");
            }
            if (indexHandle.indexOf("/") === -1) {
                return this._idPrefix + indexHandle;
            }
            return indexHandle;
        }
    }, {
        key: "_get",
        value: function _get(path, qs) {
            return this._connection.request({ path: "/_api/collection/" + this.name + "/" + path, qs: qs }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "_put",
        value: function _put(path, body) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/collection/" + this.name + "/" + path,
                body: body
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/collection/" + this.name }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === exports.COLLECTION_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "create",
        value: function create(properties) {
            return this._connection.request({
                method: "POST",
                path: "/_api/collection",
                body: _extends({}, properties, {
                    name: this.name,
                    type: this.type
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "properties",
        value: function properties() {
            return this._get("properties");
        }
    }, {
        key: "count",
        value: function count() {
            return this._get("count");
        }
    }, {
        key: "figures",
        value: function figures() {
            return this._get("figures");
        }
    }, {
        key: "revision",
        value: function revision() {
            return this._get("revision");
        }
    }, {
        key: "checksum",
        value: function checksum(opts) {
            return this._get("checksum", opts);
        }
    }, {
        key: "load",
        value: function load(count) {
            return this._put("load", typeof count === "boolean" ? { count: count } : undefined);
        }
    }, {
        key: "unload",
        value: function unload() {
            return this._put("unload", undefined);
        }
    }, {
        key: "setProperties",
        value: function setProperties(properties) {
            return this._put("properties", properties);
        }
    }, {
        key: "rename",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
                var result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/collection/" + this.name + "/rename",
                                    body: { name: name }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context.sent;

                                this.name = name;
                                this._idPrefix = name + "/";
                                return _context.abrupt("return", result);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function rename(_x) {
                return _ref.apply(this, arguments);
            }

            return rename;
        }()
    }, {
        key: "rotate",
        value: function rotate() {
            return this._put("rotate", undefined);
        }
    }, {
        key: "truncate",
        value: function truncate() {
            return this._put("truncate", undefined);
        }
    }, {
        key: "drop",
        value: function drop(opts) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/collection/" + this.name,
                qs: opts
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "documentExists",
        value: function documentExists(documentHandle) {
            return this._connection.request({
                method: "HEAD",
                path: "/_api/" + this._documentPath(documentHandle)
            }, function () {
                return true;
            }).catch(function (err) {
                if (err.statusCode === 404) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "document",
        value: function document(documentHandle) {
            var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var result = this._connection.request({ path: "/_api/" + this._documentPath(documentHandle) }, function (res) {
                return res.body;
            });
            if (!graceful) return result;
            return result.catch(function (err) {
                if (error_1.isArangoError(err) && err.errorNum === exports.DOCUMENT_NOT_FOUND) {
                    return null;
                }
                throw err;
            });
        }
    }, {
        key: "replace",
        value: function replace(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev && this._connection.arangoMajor >= 3) {
                var rev = void 0;
                var _opts = opts;
                rev = _opts.rev;
                opts = _objectWithoutProperties(_opts, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/" + this._documentPath(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "update",
        value: function update(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev && this._connection.arangoMajor >= 3) {
                var rev = void 0;
                var _opts2 = opts;
                rev = _opts2.rev;
                opts = _objectWithoutProperties(_opts2, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PATCH",
                path: "/_api/" + this._documentPath(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "bulkUpdate",
        value: function bulkUpdate(newValues, opts) {
            return this._connection.request({
                method: "PATCH",
                path: "/_api/document/" + this.name,
                body: newValues,
                qs: opts
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "remove",
        value: function remove(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev && this._connection.arangoMajor >= 3) {
                var rev = void 0;
                var _opts3 = opts;
                rev = _opts3.rev;
                opts = _objectWithoutProperties(_opts3, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/" + this._documentPath(documentHandle),
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "list",
        value: function list() {
            var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "id";

            if (this._connection.arangoMajor <= 2) {
                return this._connection.request({
                    path: "/_api/document",
                    qs: { type: type, collection: this.name }
                }, function (res) {
                    return res.body.documents;
                });
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/all-keys",
                body: { type: type, collection: this.name }
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "all",
        value: function all(opts) {
            var _this = this;

            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/all",
                body: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this._connection, res.body, res.host);
            });
        }
    }, {
        key: "any",
        value: function any() {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/any",
                body: { collection: this.name }
            }, function (res) {
                return res.body.document;
            });
        }
    }, {
        key: "first",
        value: function first(opts) {
            if (typeof opts === "number") {
                opts = { count: opts };
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/first",
                body: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "last",
        value: function last(opts) {
            if (typeof opts === "number") {
                opts = { count: opts };
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/last",
                body: _extends({}, opts, {
                    collection: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "byExample",
        value: function byExample(example, opts) {
            var _this2 = this;

            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/by-example",
                body: _extends({}, opts, {
                    example: example,
                    collection: this.name
                })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this2._connection, res.body, res.host);
            });
        }
    }, {
        key: "firstExample",
        value: function firstExample(example) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/first-example",
                body: {
                    example: example,
                    collection: this.name
                }
            }, function (res) {
                return res.body.document;
            });
        }
    }, {
        key: "removeByExample",
        value: function removeByExample(example, opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/remove-by-example",
                body: _extends({}, opts, {
                    example: example,
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "replaceByExample",
        value: function replaceByExample(example, newValue, opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/replace-by-example",
                body: _extends({}, opts, {
                    example: example,
                    newValue: newValue,
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "updateByExample",
        value: function updateByExample(example, newValue, opts) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/update-by-example",
                body: _extends({}, opts, {
                    example: example,
                    newValue: newValue,
                    collection: this.name
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "lookupByKeys",
        value: function lookupByKeys(keys) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/lookup-by-keys",
                body: {
                    keys: keys,
                    collection: this.name
                }
            }, function (res) {
                return res.body.documents;
            });
        }
    }, {
        key: "removeByKeys",
        value: function removeByKeys(keys, options) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/remove-by-keys",
                body: {
                    options: options,
                    keys: keys,
                    collection: this.name
                }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "import",
        value: function _import(data, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/import",
                body: data,
                isJsonStream: Boolean(!opts || opts.type !== "array"),
                qs: _extends({ type: "auto" }, opts, { collection: this.name })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "indexes",
        value: function indexes() {
            return this._connection.request({
                path: "/_api/index",
                qs: { collection: this.name }
            }, function (res) {
                return res.body.indexes;
            });
        }
    }, {
        key: "index",
        value: function index(indexHandle) {
            return this._connection.request({ path: "/_api/index/" + this._indexHandle(indexHandle) }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createIndex",
        value: function createIndex(details) {
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: details,
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "dropIndex",
        value: function dropIndex(indexHandle) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/index/" + this._indexHandle(indexHandle)
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createCapConstraint",
        value: function createCapConstraint(opts) {
            if (typeof opts === "number") {
                opts = { size: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({}, opts, { type: "cap" }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createHashIndex",
        value: function createHashIndex(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            if (typeof opts === "boolean") {
                opts = { unique: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({ unique: false }, opts, { type: "hash", fields: fields }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createSkipList",
        value: function createSkipList(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            if (typeof opts === "boolean") {
                opts = { unique: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({ unique: false }, opts, { type: "skiplist", fields: fields }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createPersistentIndex",
        value: function createPersistentIndex(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            if (typeof opts === "boolean") {
                opts = { unique: opts };
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({ unique: false }, opts, { type: "persistent", fields: fields }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createGeoIndex",
        value: function createGeoIndex(fields, opts) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: _extends({}, opts, { fields: fields, type: "geo" }),
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createFulltextIndex",
        value: function createFulltextIndex(fields, minLength) {
            if (typeof fields === "string") {
                fields = [fields];
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/index",
                body: { fields: fields, minLength: minLength, type: "fulltext" },
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "fulltext",
        value: function fulltext(attribute, query) {
            var _this3 = this;

            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            if (opts.index) opts.index = this._indexHandle(opts.index);
            return this._connection.request({
                method: "PUT",
                path: "/_api/simple/fulltext",
                body: _extends({}, opts, {
                    attribute: attribute,
                    query: query,
                    collection: this.name
                })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this3._connection, res.body, res.host);
            });
        }
    }]);

    return BaseCollection;
}();

exports.BaseCollection = BaseCollection;

var DocumentCollection = function (_BaseCollection) {
    _inherits(DocumentCollection, _BaseCollection);

    function DocumentCollection(connection, name) {
        _classCallCheck(this, DocumentCollection);

        var _this4 = _possibleConstructorReturn(this, (DocumentCollection.__proto__ || Object.getPrototypeOf(DocumentCollection)).call(this, connection, name));

        _this4.type = CollectionType.DOCUMENT_COLLECTION;
        return _this4;
    }

    _createClass(DocumentCollection, [{
        key: "save",
        value: function save(data, opts) {
            if (typeof opts === "boolean") {
                opts = { returnNew: opts };
            }
            if (this._connection.arangoMajor <= 2) {
                return this._connection.request({
                    method: "POST",
                    path: "/_api/document",
                    body: data,
                    qs: _extends({}, opts, {
                        collection: this.name
                    })
                }, function (res) {
                    return res.body;
                });
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/document/" + this.name,
                body: data,
                qs: opts
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return DocumentCollection;
}(BaseCollection);

exports.DocumentCollection = DocumentCollection;

var EdgeCollection = function (_BaseCollection2) {
    _inherits(EdgeCollection, _BaseCollection2);

    function EdgeCollection(connection, name) {
        _classCallCheck(this, EdgeCollection);

        var _this5 = _possibleConstructorReturn(this, (EdgeCollection.__proto__ || Object.getPrototypeOf(EdgeCollection)).call(this, connection, name));

        _this5.type = CollectionType.EDGE_COLLECTION;
        return _this5;
    }

    _createClass(EdgeCollection, [{
        key: "_documentPath",
        value: function _documentPath(documentHandle) {
            if (this._connection.arangoMajor < 3) {
                return "edge/" + this._documentHandle(documentHandle);
            }
            return "document/" + this._documentHandle(documentHandle);
        }
    }, {
        key: "edge",
        value: function edge(documentHandle) {
            var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.document(documentHandle, graceful);
        }
    }, {
        key: "save",
        value: function save(data, fromIdOrOpts, toId, opts) {
            if (toId !== undefined) {
                data._from = this._documentHandle(fromIdOrOpts);
                data._to = this._documentHandle(toId);
            } else if (fromIdOrOpts !== undefined) {
                opts = fromIdOrOpts;
            }
            if (typeof opts === "boolean") {
                opts = { returnNew: opts };
            }
            if (this._connection.arangoMajor <= 2) {
                return this._connection.request({
                    method: "POST",
                    path: "/_api/edge",
                    body: data,
                    qs: _extends({}, opts, {
                        collection: this.name,
                        from: data._from,
                        to: data._to
                    })
                }, function (res) {
                    return res.body;
                });
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/document",
                body: data,
                qs: { collection: this.name }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "_edges",
        value: function _edges(documentHandle, direction) {
            return this._connection.request({
                path: "/_api/edges/" + this.name,
                qs: {
                    direction: direction,
                    vertex: this._documentHandle(documentHandle)
                }
            }, function (res) {
                return res.body.edges;
            });
        }
    }, {
        key: "edges",
        value: function edges(vertex) {
            return this._edges(vertex, undefined);
        }
    }, {
        key: "inEdges",
        value: function inEdges(vertex) {
            return this._edges(vertex, "in");
        }
    }, {
        key: "outEdges",
        value: function outEdges(vertex) {
            return this._edges(vertex, "out");
        }
    }, {
        key: "traversal",
        value: function traversal(startVertex, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/traversal",
                body: _extends({}, opts, {
                    startVertex: startVertex,
                    edgeCollection: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }]);

    return EdgeCollection;
}(BaseCollection);

exports.EdgeCollection = EdgeCollection;
function constructCollection(connection, data) {
    var Collection = data.type === CollectionType.EDGE_COLLECTION ? EdgeCollection : DocumentCollection;
    return new Collection(connection, data.name);
}
exports.constructCollection = constructCollection;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function get() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function get() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = __webpack_require__(1);
function isAqlQuery(query) {
    return Boolean(query && query.query && query.bindVars);
}
exports.isAqlQuery = isAqlQuery;
function isAqlLiteral(literal) {
    return Boolean(literal && typeof literal.toAQL === "function");
}
exports.isAqlLiteral = isAqlLiteral;
function aql(strings) {
    var bindVars = {};
    var bindVals = [];
    var query = strings[0];

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
    }

    for (var i = 0; i < args.length; i++) {
        var rawValue = args[i];
        var value = rawValue;
        if (isAqlLiteral(rawValue)) {
            query += "" + rawValue.toAQL() + strings[i + 1];
            continue;
        }
        var index = bindVals.indexOf(rawValue);
        var isKnown = index !== -1;
        var name = "value" + (isKnown ? index : bindVals.length);
        if (collection_1.isArangoCollection(rawValue)) {
            name = "@" + name;
            value = rawValue.name;
        }
        if (!isKnown) {
            bindVals.push(rawValue);
            bindVars[name] = value;
        }
        query += "@" + name + strings[i + 1];
    }
    return { query: query, bindVars: bindVars };
}
exports.aql = aql;
(function (aql) {
    aql.literal = function (value) {
        return {
            toAQL: function toAQL() {
                return String(value);
            }
        };
    };
})(aql = exports.aql || (exports.aql = {}));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var ArrayCursor = function () {
    function ArrayCursor(connection, body, host) {
        _classCallCheck(this, ArrayCursor);

        this.extra = body.extra;
        this._connection = connection;
        this._result = body.result;
        this._hasMore = Boolean(body.hasMore);
        this._id = body.id;
        this._host = host;
        this.count = body.count;
    }

    _createClass(ArrayCursor, [{
        key: "_drain",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._more();

                            case 2:
                                if (this._hasMore) {
                                    _context.next = 4;
                                    break;
                                }

                                return _context.abrupt("return", this);

                            case 4:
                                return _context.abrupt("return", this._drain());

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function _drain() {
                return _ref.apply(this, arguments);
            }

            return _drain;
        }()
    }, {
        key: "_more",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _result, res;

                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                if (this._hasMore) {
                                    _context2.next = 4;
                                    break;
                                }

                                return _context2.abrupt("return");

                            case 4:
                                _context2.next = 6;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/cursor/" + this._id,
                                    host: this._host
                                });

                            case 6:
                                res = _context2.sent;

                                (_result = this._result).push.apply(_result, _toConsumableArray(res.body.result));
                                this._hasMore = res.body.hasMore;

                            case 9:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function _more() {
                return _ref2.apply(this, arguments);
            }

            return _more;
        }()
    }, {
        key: "all",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var result;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this._drain();

                            case 2:
                                result = this._result;

                                this._result = [];
                                return _context3.abrupt("return", result);

                            case 5:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function all() {
                return _ref3.apply(this, arguments);
            }

            return all;
        }()
    }, {
        key: "next",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                if (!(!this._result.length && this._hasMore)) {
                                    _context4.next = 5;
                                    break;
                                }

                                _context4.next = 3;
                                return this._more();

                            case 3:
                                _context4.next = 0;
                                break;

                            case 5:
                                if (this._result.length) {
                                    _context4.next = 7;
                                    break;
                                }

                                return _context4.abrupt("return", undefined);

                            case 7:
                                return _context4.abrupt("return", this._result.shift());

                            case 8:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function next() {
                return _ref4.apply(this, arguments);
            }

            return next;
        }()
    }, {
        key: "hasNext",
        value: function hasNext() {
            return Boolean(this._hasMore || this._result.length);
        }
    }, {
        key: "each",
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                index = 0;

                            case 1:
                                if (!(this._result.length || this._hasMore)) {
                                    _context5.next = 15;
                                    break;
                                }

                                result = void 0;

                            case 3:
                                if (!this._result.length) {
                                    _context5.next = 10;
                                    break;
                                }

                                result = fn(this._result.shift(), index, this);
                                index++;

                                if (!(result === false)) {
                                    _context5.next = 8;
                                    break;
                                }

                                return _context5.abrupt("return", result);

                            case 8:
                                _context5.next = 3;
                                break;

                            case 10:
                                if (!this._hasMore) {
                                    _context5.next = 13;
                                    break;
                                }

                                _context5.next = 13;
                                return this._more();

                            case 13:
                                _context5.next = 1;
                                break;

                            case 15:
                                return _context5.abrupt("return", true);

                            case 16:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function each(_x) {
                return _ref5.apply(this, arguments);
            }

            return each;
        }()
    }, {
        key: "every",
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                index = 0;

                            case 1:
                                if (!(this._result.length || this._hasMore)) {
                                    _context6.next = 15;
                                    break;
                                }

                                result = void 0;

                            case 3:
                                if (!this._result.length) {
                                    _context6.next = 10;
                                    break;
                                }

                                result = fn(this._result.shift(), index, this);
                                index++;

                                if (result) {
                                    _context6.next = 8;
                                    break;
                                }

                                return _context6.abrupt("return", false);

                            case 8:
                                _context6.next = 3;
                                break;

                            case 10:
                                if (!this._hasMore) {
                                    _context6.next = 13;
                                    break;
                                }

                                _context6.next = 13;
                                return this._more();

                            case 13:
                                _context6.next = 1;
                                break;

                            case 15:
                                return _context6.abrupt("return", true);

                            case 16:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function every(_x2) {
                return _ref6.apply(this, arguments);
            }

            return every;
        }()
    }, {
        key: "some",
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                index = 0;

                            case 1:
                                if (!(this._result.length || this._hasMore)) {
                                    _context7.next = 15;
                                    break;
                                }

                                result = void 0;

                            case 3:
                                if (!this._result.length) {
                                    _context7.next = 10;
                                    break;
                                }

                                result = fn(this._result.shift(), index, this);
                                index++;

                                if (!result) {
                                    _context7.next = 8;
                                    break;
                                }

                                return _context7.abrupt("return", true);

                            case 8:
                                _context7.next = 3;
                                break;

                            case 10:
                                if (!this._hasMore) {
                                    _context7.next = 13;
                                    break;
                                }

                                _context7.next = 13;
                                return this._more();

                            case 13:
                                _context7.next = 1;
                                break;

                            case 15:
                                return _context7.abrupt("return", false);

                            case 16:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function some(_x3) {
                return _ref7.apply(this, arguments);
            }

            return some;
        }()
    }, {
        key: "map",
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(fn) {
                var index, result;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                index = 0;
                                result = [];

                            case 2:
                                if (!(this._result.length || this._hasMore)) {
                                    _context8.next = 9;
                                    break;
                                }

                                while (this._result.length) {
                                    result.push(fn(this._result.shift(), index, this));
                                    index++;
                                }

                                if (!this._hasMore) {
                                    _context8.next = 7;
                                    break;
                                }

                                _context8.next = 7;
                                return this._more();

                            case 7:
                                _context8.next = 2;
                                break;

                            case 9:
                                return _context8.abrupt("return", result);

                            case 10:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function map(_x4) {
                return _ref8.apply(this, arguments);
            }

            return map;
        }()
    }, {
        key: "reduce",
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(fn, accu) {
                var index;
                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                index = 0;

                                if (!(accu === undefined)) {
                                    _context9.next = 7;
                                    break;
                                }

                                if (!(!this._result.length && !this._hasMore)) {
                                    _context9.next = 5;
                                    break;
                                }

                                _context9.next = 5;
                                return this._more();

                            case 5:
                                accu = this._result.shift();
                                index += 1;

                            case 7:
                                if (!(this._result.length || this._hasMore)) {
                                    _context9.next = 14;
                                    break;
                                }

                                while (this._result.length) {
                                    accu = fn(accu, this._result.shift(), index, this);
                                    index++;
                                }

                                if (!this._hasMore) {
                                    _context9.next = 12;
                                    break;
                                }

                                _context9.next = 12;
                                return this._more();

                            case 12:
                                _context9.next = 7;
                                break;

                            case 14:
                                return _context9.abrupt("return", accu);

                            case 15:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this);
            }));

            function reduce(_x5, _x6) {
                return _ref9.apply(this, arguments);
            }

            return reduce;
        }()
    }]);

    return ArrayCursor;
}();

exports.ArrayCursor = ArrayCursor;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(17);
exports.encode = exports.stringify = __webpack_require__(18);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 7 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = __webpack_require__(1);
var error_1 = __webpack_require__(0);

var GraphVertexCollection = function (_collection_1$BaseCol) {
    _inherits(GraphVertexCollection, _collection_1$BaseCol);

    function GraphVertexCollection(connection, name, graph) {
        _classCallCheck(this, GraphVertexCollection);

        var _this = _possibleConstructorReturn(this, (GraphVertexCollection.__proto__ || Object.getPrototypeOf(GraphVertexCollection)).call(this, connection, name));

        _this.type = collection_1.CollectionType.DOCUMENT_COLLECTION;
        _this.graph = graph;
        return _this;
    }

    _createClass(GraphVertexCollection, [{
        key: "document",
        value: function document(documentHandle) {
            var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var result = this._connection.request({
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle)
            }, function (res) {
                return res.body.vertex;
            });
            if (!graceful) return result;
            return result.catch(function (err) {
                if (error_1.isArangoError(err) && err.errorNum === collection_1.DOCUMENT_NOT_FOUND) {
                    return null;
                }
                throw err;
            });
        }
    }, {
        key: "vertex",
        value: function vertex(documentHandle) {
            var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this.document(documentHandle, graceful);
        }
    }, {
        key: "save",
        value: function save(data, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this.name,
                body: data,
                qs: opts
            }, function (res) {
                return res.body.vertex;
            });
        }
    }, {
        key: "replace",
        value: function replace(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts = opts;
                rev = _opts.rev;
                opts = _objectWithoutProperties(_opts, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.vertex;
            });
        }
    }, {
        key: "update",
        value: function update(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts2 = opts;
                rev = _opts2.rev;
                opts = _objectWithoutProperties(_opts2, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PATCH",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.vertex;
            });
        }
    }, {
        key: "remove",
        value: function remove(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts3 = opts;
                rev = _opts3.rev;
                opts = _objectWithoutProperties(_opts3, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.graph.name + "/vertex/" + this._documentHandle(documentHandle),
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.removed;
            });
        }
    }]);

    return GraphVertexCollection;
}(collection_1.BaseCollection);

exports.GraphVertexCollection = GraphVertexCollection;

var GraphEdgeCollection = function (_collection_1$EdgeCol) {
    _inherits(GraphEdgeCollection, _collection_1$EdgeCol);

    function GraphEdgeCollection(connection, name, graph) {
        _classCallCheck(this, GraphEdgeCollection);

        var _this2 = _possibleConstructorReturn(this, (GraphEdgeCollection.__proto__ || Object.getPrototypeOf(GraphEdgeCollection)).call(this, connection, name));

        _this2.type = collection_1.CollectionType.EDGE_COLLECTION;
        _this2.type = collection_1.CollectionType.EDGE_COLLECTION;
        _this2.graph = graph;
        return _this2;
    }

    _createClass(GraphEdgeCollection, [{
        key: "document",
        value: function document(documentHandle) {
            var graceful = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var result = this._connection.request({
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle)
            }, function (res) {
                return res.body.edge;
            });
            if (!graceful) return result;
            return result.catch(function (err) {
                if (error_1.isArangoError(err) && err.errorNum === collection_1.DOCUMENT_NOT_FOUND) {
                    return null;
                }
                throw err;
            });
        }
    }, {
        key: "save",
        value: function save(data, fromId, toId, opts) {
            if (fromId !== undefined) {
                if (toId !== undefined) {
                    data._from = this._documentHandle(fromId);
                    data._to = this._documentHandle(toId);
                } else {
                    opts = fromId;
                }
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this.name,
                body: data,
                qs: opts
            }, function (res) {
                return res.body.edge;
            });
        }
    }, {
        key: "replace",
        value: function replace(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts4 = opts;
                rev = _opts4.rev;
                opts = _objectWithoutProperties(_opts4, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PUT",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.edge;
            });
        }
    }, {
        key: "update",
        value: function update(documentHandle, newValue) {
            var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts5 = opts;
                rev = _opts5.rev;
                opts = _objectWithoutProperties(_opts5, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "PATCH",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                body: newValue,
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.edge;
            });
        }
    }, {
        key: "remove",
        value: function remove(documentHandle) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var headers = {};
            if (typeof opts === "string") {
                opts = { rev: opts };
            }
            if (opts.rev) {
                var rev = void 0;
                var _opts6 = opts;
                rev = _opts6.rev;
                opts = _objectWithoutProperties(_opts6, ["rev"]);

                headers["if-match"] = rev;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.graph.name + "/edge/" + this._documentHandle(documentHandle),
                qs: opts,
                headers: headers
            }, function (res) {
                return res.body.removed;
            });
        }
    }]);

    return GraphEdgeCollection;
}(collection_1.EdgeCollection);

exports.GraphEdgeCollection = GraphEdgeCollection;
var GRAPH_NOT_FOUND = 1924;

var Graph = function () {
    function Graph(connection, name) {
        _classCallCheck(this, Graph);

        this.name = name;
        this._connection = connection;
    }

    _createClass(Graph, [{
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/gharial/" + this.name }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === GRAPH_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "create",
        value: function create() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            var opts = arguments[1];

            return this._connection.request({
                method: "POST",
                path: "/_api/gharial",
                body: _extends({}, properties, {
                    name: this.name
                }),
                qs: opts
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "drop",
        value: function drop() {
            var dropCollections = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.name,
                qs: { dropCollections: dropCollections }
            }, function (res) {
                return res.body.removed;
            });
        }
    }, {
        key: "vertexCollection",
        value: function vertexCollection(collectionName) {
            return new GraphVertexCollection(this._connection, collectionName, this);
        }
    }, {
        key: "listVertexCollections",
        value: function listVertexCollections(opts) {
            return this._connection.request({ path: "/_api/gharial/" + this.name + "/vertex", qs: opts }, function (res) {
                return res.body.collections;
            });
        }
    }, {
        key: "vertexCollections",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opts) {
                var _this3 = this;

                var names;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this.listVertexCollections(opts);

                            case 2:
                                names = _context.sent;
                                return _context.abrupt("return", names.map(function (name) {
                                    return new GraphVertexCollection(_this3._connection, name, _this3);
                                }));

                            case 4:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function vertexCollections(_x12) {
                return _ref.apply(this, arguments);
            }

            return vertexCollections;
        }()
    }, {
        key: "addVertexCollection",
        value: function addVertexCollection(collection) {
            if (collection_1.isArangoCollection(collection)) {
                collection = collection.name;
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.name + "/vertex",
                body: { collection: collection }
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "removeVertexCollection",
        value: function removeVertexCollection(collection) {
            var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            if (collection_1.isArangoCollection(collection)) {
                collection = collection.name;
            }
            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.name + "/vertex/" + collection,
                qs: {
                    dropCollection: dropCollection
                }
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "edgeCollection",
        value: function edgeCollection(collectionName) {
            return new GraphEdgeCollection(this._connection, collectionName, this);
        }
    }, {
        key: "listEdgeCollections",
        value: function listEdgeCollections() {
            return this._connection.request({ path: "/_api/gharial/" + this.name + "/edge" }, function (res) {
                return res.body.collections;
            });
        }
    }, {
        key: "edgeCollections",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this4 = this;

                var names;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.listEdgeCollections();

                            case 2:
                                names = _context2.sent;
                                return _context2.abrupt("return", names.map(function (name) {
                                    return new GraphEdgeCollection(_this4._connection, name, _this4);
                                }));

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function edgeCollections() {
                return _ref2.apply(this, arguments);
            }

            return edgeCollections;
        }()
    }, {
        key: "addEdgeDefinition",
        value: function addEdgeDefinition(definition) {
            return this._connection.request({
                method: "POST",
                path: "/_api/gharial/" + this.name + "/edge",
                body: definition
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "replaceEdgeDefinition",
        value: function replaceEdgeDefinition(definitionName, definition) {
            return this._connection.request({
                method: "PUT",
                path: "/_api/gharial/" + this.name + "/edge/" + definitionName,
                body: definition
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "removeEdgeDefinition",
        value: function removeEdgeDefinition(definitionName) {
            var dropCollection = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this._connection.request({
                method: "DELETE",
                path: "/_api/gharial/" + this.name + "/edge/" + definitionName,
                qs: {
                    dropCollection: dropCollection
                }
            }, function (res) {
                return res.body.graph;
            });
        }
    }, {
        key: "traversal",
        value: function traversal(startVertex, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/traversal",
                body: _extends({}, opts, {
                    startVertex: startVertex,
                    graphName: this.name
                })
            }, function (res) {
                return res.body.result;
            });
        }
    }]);

    return Graph;
}();

exports.Graph = Graph;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(10);
module.exports = __webpack_require__(11);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!function (global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = ( false ? "undefined" : _typeof(module)) === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      prototype[method] = function (arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function (genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor ? ctor === GeneratorFunction ||
    // For the native GeneratorFunction constructor, the best we can
    // do is to check its .name property.
    (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
  };

  runtime.mark = function (genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function (arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function (unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function (resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
      // If enqueue has been called before, then we want to wait until
      // all previous Promises have been resolved before calling invoke,
      // so that results are always delivered in the correct order. If
      // enqueue has not been called before, then it is important to
      // call invoke immediately, without waiting on a callback to fire,
      // so that the async generator function has the opportunity to do
      // any necessary setup in a predictable way. This predictability
      // is why the Promise constructor synchronously invokes its
      // executor callback, and why async functions synchronously
      // execute code before the first await. Since we implement simple
      // async functions in terms of async generators, it is especially
      // important to get this right, even though it requires care.
      previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
      // Avoid propagating failures to Promises returned by later
      // invocations of the iterator.
      callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function (innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));

    return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
    : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;
        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);
        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done ? GenStateCompleted : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };
        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError("The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (!info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }
    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function () {
    return this;
  };

  Gp.toString = function () {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function (object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1,
            next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function reset(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function stop() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function dispatchException(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !!caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }
          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }
          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function complete(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" || record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
}(
// In sloppy mode, unbound `this` refers to the global object, fallback to
// Function constructor if we're in global strict mode. That is sadly a form
// of indirect eval which violates Content Security Policy.
function () {
  return this;
}() || Function("return this")());
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(12).default;
module.exports.default = module.exports;
Object.defineProperty(module.exports, "__esModule", { value: true });

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var aql_query_1 = __webpack_require__(3);
exports.aql = aql_query_1.aql;
var collection_1 = __webpack_require__(1);
var database_1 = __webpack_require__(15);
exports.Database = database_1.Database;
var error_1 = __webpack_require__(0);
function arangojs(config) {
    return new database_1.Database(config);
}
exports.default = arangojs;
Object.assign(arangojs, { CollectionType: collection_1.CollectionType, ArangoError: error_1.ArangoError, Database: database_1.Database, aql: aql_query_1.aql });
var collection_2 = __webpack_require__(1);
exports.DocumentCollection = collection_2.DocumentCollection;
exports.EdgeCollection = collection_2.EdgeCollection;
var graph_1 = __webpack_require__(8);
exports.Graph = graph_1.Graph;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var ExtendableError = __webpack_require__(14);
ExtendableError = ExtendableError.default || ExtendableError;
exports.default = ExtendableError;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && ((typeof call === "undefined" ? "undefined" : _typeof(call)) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : _typeof(superClass)));
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

exports.default = ExtendableError;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var aql_query_1 = __webpack_require__(3);
var collection_1 = __webpack_require__(1);
var connection_1 = __webpack_require__(16);
var cursor_1 = __webpack_require__(4);
var error_1 = __webpack_require__(0);
var graph_1 = __webpack_require__(8);
var route_1 = __webpack_require__(38);
var btoa_1 = __webpack_require__(39);
var multipart_1 = __webpack_require__(40);
var view_1 = __webpack_require__(41);
function colToString(collection) {
    if (collection_1.isArangoCollection(collection)) {
        return String(collection.name);
    } else return String(collection);
}
var DATABASE_NOT_FOUND = 1228;

var Database = function () {
    function Database(config) {
        _classCallCheck(this, Database);

        this._connection = new connection_1.Connection(config);
        this.useBasicAuth();
    }

    _createClass(Database, [{
        key: "route",
        value: function route(path, headers) {
            return new route_1.Route(this._connection, path, headers);
        }
    }, {
        key: "acquireHostList",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var urls;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (this._connection.getDatabaseName()) {
                                    _context.next = 2;
                                    break;
                                }

                                throw new Error("Cannot acquire host list with absolute URL");

                            case 2:
                                _context.next = 4;
                                return this._connection.request({ path: "/_api/cluster/endpoints" }, function (res) {
                                    return res.body.endpoints.map(function (endpoint) {
                                        return endpoint.endpoint;
                                    });
                                });

                            case 4:
                                urls = _context.sent;

                                this._connection.addToHostList(urls);

                            case 6:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function acquireHostList() {
                return _ref.apply(this, arguments);
            }

            return acquireHostList;
        }()
    }, {
        key: "close",
        value: function close() {
            this._connection.close();
        }
        // Database manipulation

    }, {
        key: "useDatabase",
        value: function useDatabase(databaseName) {
            this._connection.setDatabaseName(databaseName);
            return this;
        }
    }, {
        key: "useBearerAuth",
        value: function useBearerAuth(token) {
            this._connection.setHeader("authorization", "Bearer " + token);
            return this;
        }
    }, {
        key: "useBasicAuth",
        value: function useBasicAuth() {
            var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "root";
            var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            this._connection.setHeader("authorization", "Basic " + btoa_1.btoa(username + ":" + password));
            return this;
        }
    }, {
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/database/current" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === DATABASE_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "createDatabase",
        value: function createDatabase(databaseName, users) {
            return this._connection.request({
                method: "POST",
                path: "/_api/database",
                body: { users: users, name: databaseName }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "listDatabases",
        value: function listDatabases() {
            return this._connection.request({ path: "/_api/database" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "listUserDatabases",
        value: function listUserDatabases() {
            return this._connection.request({ path: "/_api/database/user" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "dropDatabase",
        value: function dropDatabase(databaseName) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/database/" + databaseName
            }, function (res) {
                return res.body;
            });
        }
        // Collection manipulation

    }, {
        key: "collection",
        value: function collection(collectionName) {
            return new collection_1.DocumentCollection(this._connection, collectionName);
        }
    }, {
        key: "edgeCollection",
        value: function edgeCollection(collectionName) {
            return new collection_1.EdgeCollection(this._connection, collectionName);
        }
    }, {
        key: "listCollections",
        value: function listCollections() {
            var _this = this;

            var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

            return this._connection.request({
                path: "/_api/collection",
                qs: { excludeSystem: excludeSystem }
            }, function (res) {
                return _this._connection.arangoMajor <= 2 ? res.body.collections : res.body.result;
            });
        }
    }, {
        key: "collections",
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var _this2 = this;

                var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var collections;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.listCollections(excludeSystem);

                            case 2:
                                collections = _context2.sent;
                                return _context2.abrupt("return", collections.map(function (data) {
                                    return collection_1.constructCollection(_this2._connection, data);
                                }));

                            case 4:
                            case "end":
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function collections() {
                return _ref2.apply(this, arguments);
            }

            return collections;
        }()
    }, {
        key: "truncate",
        value: function () {
            var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                var _this3 = this;

                var excludeSystem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                var collections;
                return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                        switch (_context3.prev = _context3.next) {
                            case 0:
                                _context3.next = 2;
                                return this.listCollections(excludeSystem);

                            case 2:
                                collections = _context3.sent;
                                _context3.next = 5;
                                return Promise.all(collections.map(function (data) {
                                    return _this3._connection.request({
                                        method: "PUT",
                                        path: "/_api/collection/" + data.name + "/truncate"
                                    }, function (res) {
                                        return res.body;
                                    });
                                }));

                            case 5:
                                return _context3.abrupt("return", _context3.sent);

                            case 6:
                            case "end":
                                return _context3.stop();
                        }
                    }
                }, _callee3, this);
            }));

            function truncate() {
                return _ref3.apply(this, arguments);
            }

            return truncate;
        }()
        // Views

    }, {
        key: "arangoSearchView",
        value: function arangoSearchView(viewName) {
            return new view_1.ArangoSearchView(this._connection, viewName);
        }
    }, {
        key: "listViews",
        value: function listViews() {
            return this._connection.request({ path: "/_api/view" }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "views",
        value: function () {
            var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
                var _this4 = this;

                var views;
                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                        switch (_context4.prev = _context4.next) {
                            case 0:
                                _context4.next = 2;
                                return this.listViews();

                            case 2:
                                views = _context4.sent;
                                return _context4.abrupt("return", views.map(function (data) {
                                    return view_1.constructView(_this4._connection, data);
                                }));

                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }
                }, _callee4, this);
            }));

            function views() {
                return _ref4.apply(this, arguments);
            }

            return views;
        }()
        // Graph manipulation

    }, {
        key: "graph",
        value: function graph(graphName) {
            return new graph_1.Graph(this._connection, graphName);
        }
    }, {
        key: "listGraphs",
        value: function listGraphs() {
            return this._connection.request({ path: "/_api/gharial" }, function (res) {
                return res.body.graphs;
            });
        }
    }, {
        key: "graphs",
        value: function () {
            var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                var _this5 = this;

                var graphs;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                        switch (_context5.prev = _context5.next) {
                            case 0:
                                _context5.next = 2;
                                return this.listGraphs();

                            case 2:
                                graphs = _context5.sent;
                                return _context5.abrupt("return", graphs.map(function (data) {
                                    return _this5.graph(data._key);
                                }));

                            case 4:
                            case "end":
                                return _context5.stop();
                        }
                    }
                }, _callee5, this);
            }));

            function graphs() {
                return _ref5.apply(this, arguments);
            }

            return graphs;
        }()
    }, {
        key: "transaction",
        value: function transaction(collections, action, params, options) {
            if (typeof params === "number") {
                options = params;
                params = undefined;
            }
            if (typeof options === "number") {
                options = { lockTimeout: options };
            }
            if (typeof collections === "string") {
                collections = { write: [collections] };
            } else if (Array.isArray(collections)) {
                collections = { write: collections.map(colToString) };
            } else if (collection_1.isArangoCollection(collections)) {
                collections = { write: colToString(collections) };
            } else if (collections && (typeof collections === "undefined" ? "undefined" : _typeof(collections)) === "object") {
                collections = _extends({}, collections);
                if (collections.read) {
                    if (!Array.isArray(collections.read)) {
                        collections.read = colToString(collections.read);
                    } else collections.read = collections.read.map(colToString);
                }
                if (collections.write) {
                    if (!Array.isArray(collections.write)) {
                        collections.write = colToString(collections.write);
                    } else collections.write = collections.write.map(colToString);
                }
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/transaction",
                body: _extends({
                    collections: collections,
                    action: action,
                    params: params
                }, options)
            }, function (res) {
                return res.body.result;
            });
        }
    }, {
        key: "query",
        value: function query(_query, bindVars, opts) {
            var _this6 = this;

            if (aql_query_1.isAqlQuery(_query)) {
                opts = bindVars;
                bindVars = _query.bindVars;
                _query = _query.query;
            } else if (aql_query_1.isAqlLiteral(_query)) {
                _query = _query.toAQL();
            }
            return this._connection.request({
                method: "POST",
                path: "/_api/cursor",
                body: _extends({}, opts, { query: _query, bindVars: bindVars })
            }, function (res) {
                return new cursor_1.ArrayCursor(_this6._connection, res.body, res.host);
            });
        }
        // Function management

    }, {
        key: "listFunctions",
        value: function listFunctions() {
            return this._connection.request({ path: "/_api/aqlfunction" }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "createFunction",
        value: function createFunction(name, code) {
            return this._connection.request({
                method: "POST",
                path: "/_api/aqlfunction",
                body: { name: name, code: code }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "dropFunction",
        value: function dropFunction(name) {
            var group = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            return this._connection.request({
                method: "DELETE",
                path: "/_api/aqlfunction/" + name,
                body: { group: group }
            }, function (res) {
                return res.body;
            });
        }
        // Service management

    }, {
        key: "listServices",
        value: function listServices() {
            return this._connection.request({ path: "/_api/foxx" }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "installService",
        value: function () {
            var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(mount, source) {
                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var configuration, dependencies, qs, req;
                return regeneratorRuntime.wrap(function _callee6$(_context6) {
                    while (1) {
                        switch (_context6.prev = _context6.next) {
                            case 0:
                                configuration = opts.configuration, dependencies = opts.dependencies, qs = _objectWithoutProperties(opts, ["configuration", "dependencies"]);
                                _context6.next = 3;
                                return multipart_1.toForm({
                                    configuration: configuration,
                                    dependencies: dependencies,
                                    source: source
                                });

                            case 3:
                                req = _context6.sent;
                                _context6.next = 6;
                                return this._connection.request(_extends({}, req, {
                                    method: "POST",
                                    path: "/_api/foxx",
                                    isBinary: true,
                                    qs: _extends({}, qs, { mount: mount })
                                }), function (res) {
                                    return res.body;
                                });

                            case 6:
                                return _context6.abrupt("return", _context6.sent);

                            case 7:
                            case "end":
                                return _context6.stop();
                        }
                    }
                }, _callee6, this);
            }));

            function installService(_x8, _x9) {
                return _ref6.apply(this, arguments);
            }

            return installService;
        }()
    }, {
        key: "upgradeService",
        value: function () {
            var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(mount, source) {
                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var configuration, dependencies, qs, req;
                return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                        switch (_context7.prev = _context7.next) {
                            case 0:
                                configuration = opts.configuration, dependencies = opts.dependencies, qs = _objectWithoutProperties(opts, ["configuration", "dependencies"]);
                                _context7.next = 3;
                                return multipart_1.toForm({
                                    configuration: configuration,
                                    dependencies: dependencies,
                                    source: source
                                });

                            case 3:
                                req = _context7.sent;
                                _context7.next = 6;
                                return this._connection.request(_extends({}, req, {
                                    method: "PATCH",
                                    path: "/_api/foxx/service",
                                    isBinary: true,
                                    qs: _extends({}, qs, { mount: mount })
                                }), function (res) {
                                    return res.body;
                                });

                            case 6:
                                return _context7.abrupt("return", _context7.sent);

                            case 7:
                            case "end":
                                return _context7.stop();
                        }
                    }
                }, _callee7, this);
            }));

            function upgradeService(_x11, _x12) {
                return _ref7.apply(this, arguments);
            }

            return upgradeService;
        }()
    }, {
        key: "replaceService",
        value: function () {
            var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(mount, source) {
                var opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var configuration, dependencies, qs, req;
                return regeneratorRuntime.wrap(function _callee8$(_context8) {
                    while (1) {
                        switch (_context8.prev = _context8.next) {
                            case 0:
                                configuration = opts.configuration, dependencies = opts.dependencies, qs = _objectWithoutProperties(opts, ["configuration", "dependencies"]);
                                _context8.next = 3;
                                return multipart_1.toForm({
                                    configuration: configuration,
                                    dependencies: dependencies,
                                    source: source
                                });

                            case 3:
                                req = _context8.sent;
                                _context8.next = 6;
                                return this._connection.request(_extends({}, req, {
                                    method: "PUT",
                                    path: "/_api/foxx/service",
                                    isBinary: true,
                                    qs: _extends({}, qs, { mount: mount })
                                }), function (res) {
                                    return res.body;
                                });

                            case 6:
                                return _context8.abrupt("return", _context8.sent);

                            case 7:
                            case "end":
                                return _context8.stop();
                        }
                    }
                }, _callee8, this);
            }));

            function replaceService(_x14, _x15) {
                return _ref8.apply(this, arguments);
            }

            return replaceService;
        }()
    }, {
        key: "uninstallService",
        value: function uninstallService(mount) {
            var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            return this._connection.request({
                method: "DELETE",
                path: "/_api/foxx/service",
                qs: _extends({}, opts, { mount: mount })
            }, function () {
                return undefined;
            });
        }
    }, {
        key: "getService",
        value: function getService(mount) {
            return this._connection.request({
                path: "/_api/foxx/service",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getServiceConfiguration",
        value: function () {
            var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(mount) {
                var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                var result, values, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, key;

                return regeneratorRuntime.wrap(function _callee9$(_context9) {
                    while (1) {
                        switch (_context9.prev = _context9.next) {
                            case 0:
                                _context9.next = 2;
                                return this._connection.request({
                                    path: "/_api/foxx/configuration",
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context9.sent;

                                if (!(!minimal || !Object.keys(result).every(function (key) {
                                    return result[key].title;
                                }))) {
                                    _context9.next = 5;
                                    break;
                                }

                                return _context9.abrupt("return", result);

                            case 5:
                                values = {};
                                _iteratorNormalCompletion = true;
                                _didIteratorError = false;
                                _iteratorError = undefined;
                                _context9.prev = 9;

                                for (_iterator = Object.keys(result)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                                    key = _step.value;

                                    values[key] = result[key].current;
                                }
                                _context9.next = 17;
                                break;

                            case 13:
                                _context9.prev = 13;
                                _context9.t0 = _context9["catch"](9);
                                _didIteratorError = true;
                                _iteratorError = _context9.t0;

                            case 17:
                                _context9.prev = 17;
                                _context9.prev = 18;

                                if (!_iteratorNormalCompletion && _iterator.return) {
                                    _iterator.return();
                                }

                            case 20:
                                _context9.prev = 20;

                                if (!_didIteratorError) {
                                    _context9.next = 23;
                                    break;
                                }

                                throw _iteratorError;

                            case 23:
                                return _context9.finish(20);

                            case 24:
                                return _context9.finish(17);

                            case 25:
                                return _context9.abrupt("return", values);

                            case 26:
                            case "end":
                                return _context9.stop();
                        }
                    }
                }, _callee9, this, [[9, 13, 17, 25], [18,, 20, 24]]);
            }));

            function getServiceConfiguration(_x18) {
                return _ref9.apply(this, arguments);
            }

            return getServiceConfiguration;
        }()
    }, {
        key: "updateServiceConfiguration",
        value: function () {
            var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, key;

                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                        switch (_context10.prev = _context10.next) {
                            case 0:
                                _context10.next = 2;
                                return this._connection.request({
                                    method: "PATCH",
                                    path: "/_api/foxx/configuration",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context10.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context10.next = 5;
                                    break;
                                }

                                return _context10.abrupt("return", result);

                            case 5:
                                _context10.next = 7;
                                return this.getServiceConfiguration(mount, minimal);

                            case 7:
                                result2 = _context10.sent;

                                if (!result.warnings) {
                                    _context10.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion2 = true;
                                _didIteratorError2 = false;
                                _iteratorError2 = undefined;
                                _context10.prev = 12;

                                for (_iterator2 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                    key = _step2.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context10.next = 20;
                                break;

                            case 16:
                                _context10.prev = 16;
                                _context10.t0 = _context10["catch"](12);
                                _didIteratorError2 = true;
                                _iteratorError2 = _context10.t0;

                            case 20:
                                _context10.prev = 20;
                                _context10.prev = 21;

                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }

                            case 23:
                                _context10.prev = 23;

                                if (!_didIteratorError2) {
                                    _context10.next = 26;
                                    break;
                                }

                                throw _iteratorError2;

                            case 26:
                                return _context10.finish(23);

                            case 27:
                                return _context10.finish(20);

                            case 28:
                                return _context10.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context10.stop();
                        }
                    }
                }, _callee10, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function updateServiceConfiguration(_x20, _x21) {
                return _ref10.apply(this, arguments);
            }

            return updateServiceConfiguration;
        }()
    }, {
        key: "replaceServiceConfiguration",
        value: function () {
            var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, key;

                return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                        switch (_context11.prev = _context11.next) {
                            case 0:
                                _context11.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/foxx/configuration",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context11.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context11.next = 5;
                                    break;
                                }

                                return _context11.abrupt("return", result);

                            case 5:
                                _context11.next = 7;
                                return this.getServiceConfiguration(mount, minimal);

                            case 7:
                                result2 = _context11.sent;

                                if (!result.warnings) {
                                    _context11.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion3 = true;
                                _didIteratorError3 = false;
                                _iteratorError3 = undefined;
                                _context11.prev = 12;

                                for (_iterator3 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                                    key = _step3.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context11.next = 20;
                                break;

                            case 16:
                                _context11.prev = 16;
                                _context11.t0 = _context11["catch"](12);
                                _didIteratorError3 = true;
                                _iteratorError3 = _context11.t0;

                            case 20:
                                _context11.prev = 20;
                                _context11.prev = 21;

                                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                                    _iterator3.return();
                                }

                            case 23:
                                _context11.prev = 23;

                                if (!_didIteratorError3) {
                                    _context11.next = 26;
                                    break;
                                }

                                throw _iteratorError3;

                            case 26:
                                return _context11.finish(23);

                            case 27:
                                return _context11.finish(20);

                            case 28:
                                return _context11.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context11.stop();
                        }
                    }
                }, _callee11, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function replaceServiceConfiguration(_x23, _x24) {
                return _ref11.apply(this, arguments);
            }

            return replaceServiceConfiguration;
        }()
    }, {
        key: "getServiceDependencies",
        value: function () {
            var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(mount) {
                var minimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                var result, values, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, key;

                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                    while (1) {
                        switch (_context12.prev = _context12.next) {
                            case 0:
                                _context12.next = 2;
                                return this._connection.request({
                                    path: "/_api/foxx/dependencies",
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context12.sent;

                                if (!(!minimal || !Object.keys(result).every(function (key) {
                                    return result[key].title;
                                }))) {
                                    _context12.next = 5;
                                    break;
                                }

                                return _context12.abrupt("return", result);

                            case 5:
                                values = {};
                                _iteratorNormalCompletion4 = true;
                                _didIteratorError4 = false;
                                _iteratorError4 = undefined;
                                _context12.prev = 9;

                                for (_iterator4 = Object.keys(result)[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                                    key = _step4.value;

                                    values[key] = result[key].current;
                                }
                                _context12.next = 17;
                                break;

                            case 13:
                                _context12.prev = 13;
                                _context12.t0 = _context12["catch"](9);
                                _didIteratorError4 = true;
                                _iteratorError4 = _context12.t0;

                            case 17:
                                _context12.prev = 17;
                                _context12.prev = 18;

                                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                                    _iterator4.return();
                                }

                            case 20:
                                _context12.prev = 20;

                                if (!_didIteratorError4) {
                                    _context12.next = 23;
                                    break;
                                }

                                throw _iteratorError4;

                            case 23:
                                return _context12.finish(20);

                            case 24:
                                return _context12.finish(17);

                            case 25:
                                return _context12.abrupt("return", values);

                            case 26:
                            case "end":
                                return _context12.stop();
                        }
                    }
                }, _callee12, this, [[9, 13, 17, 25], [18,, 20, 24]]);
            }));

            function getServiceDependencies(_x26) {
                return _ref12.apply(this, arguments);
            }

            return getServiceDependencies;
        }()
    }, {
        key: "updateServiceDependencies",
        value: function () {
            var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, key;

                return regeneratorRuntime.wrap(function _callee13$(_context13) {
                    while (1) {
                        switch (_context13.prev = _context13.next) {
                            case 0:
                                _context13.next = 2;
                                return this._connection.request({
                                    method: "PATCH",
                                    path: "/_api/foxx/dependencies",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context13.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context13.next = 5;
                                    break;
                                }

                                return _context13.abrupt("return", result);

                            case 5:
                                _context13.next = 7;
                                return this.getServiceDependencies(mount, minimal);

                            case 7:
                                result2 = _context13.sent;

                                if (!result.warnings) {
                                    _context13.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion5 = true;
                                _didIteratorError5 = false;
                                _iteratorError5 = undefined;
                                _context13.prev = 12;

                                for (_iterator5 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                                    key = _step5.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context13.next = 20;
                                break;

                            case 16:
                                _context13.prev = 16;
                                _context13.t0 = _context13["catch"](12);
                                _didIteratorError5 = true;
                                _iteratorError5 = _context13.t0;

                            case 20:
                                _context13.prev = 20;
                                _context13.prev = 21;

                                if (!_iteratorNormalCompletion5 && _iterator5.return) {
                                    _iterator5.return();
                                }

                            case 23:
                                _context13.prev = 23;

                                if (!_didIteratorError5) {
                                    _context13.next = 26;
                                    break;
                                }

                                throw _iteratorError5;

                            case 26:
                                return _context13.finish(23);

                            case 27:
                                return _context13.finish(20);

                            case 28:
                                return _context13.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context13.stop();
                        }
                    }
                }, _callee13, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function updateServiceDependencies(_x28, _x29) {
                return _ref13.apply(this, arguments);
            }

            return updateServiceDependencies;
        }()
    }, {
        key: "replaceServiceDependencies",
        value: function () {
            var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(mount, cfg) {
                var minimal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

                var result, result2, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, key;

                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                    while (1) {
                        switch (_context14.prev = _context14.next) {
                            case 0:
                                _context14.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/foxx/dependencies",
                                    body: cfg,
                                    qs: { mount: mount, minimal: minimal }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context14.sent;

                                if (!(minimal || !result.values || !Object.keys(result.values).every(function (key) {
                                    return result.values[key].title;
                                }))) {
                                    _context14.next = 5;
                                    break;
                                }

                                return _context14.abrupt("return", result);

                            case 5:
                                _context14.next = 7;
                                return this.getServiceDependencies(mount, minimal);

                            case 7:
                                result2 = _context14.sent;

                                if (!result.warnings) {
                                    _context14.next = 28;
                                    break;
                                }

                                _iteratorNormalCompletion6 = true;
                                _didIteratorError6 = false;
                                _iteratorError6 = undefined;
                                _context14.prev = 12;

                                for (_iterator6 = Object.keys(result2)[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                                    key = _step6.value;

                                    result2[key].warning = result.warnings[key];
                                }
                                _context14.next = 20;
                                break;

                            case 16:
                                _context14.prev = 16;
                                _context14.t0 = _context14["catch"](12);
                                _didIteratorError6 = true;
                                _iteratorError6 = _context14.t0;

                            case 20:
                                _context14.prev = 20;
                                _context14.prev = 21;

                                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                                    _iterator6.return();
                                }

                            case 23:
                                _context14.prev = 23;

                                if (!_didIteratorError6) {
                                    _context14.next = 26;
                                    break;
                                }

                                throw _iteratorError6;

                            case 26:
                                return _context14.finish(23);

                            case 27:
                                return _context14.finish(20);

                            case 28:
                                return _context14.abrupt("return", result2);

                            case 29:
                            case "end":
                                return _context14.stop();
                        }
                    }
                }, _callee14, this, [[12, 16, 20, 28], [21,, 23, 27]]);
            }));

            function replaceServiceDependencies(_x31, _x32) {
                return _ref14.apply(this, arguments);
            }

            return replaceServiceDependencies;
        }()
    }, {
        key: "enableServiceDevelopmentMode",
        value: function enableServiceDevelopmentMode(mount) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/development",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "disableServiceDevelopmentMode",
        value: function disableServiceDevelopmentMode(mount) {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/foxx/development",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "listServiceScripts",
        value: function listServiceScripts(mount) {
            return this._connection.request({
                path: "/_api/foxx/scripts",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "runServiceScript",
        value: function runServiceScript(mount, name, args) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/scripts/" + name,
                body: args,
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "runServiceTests",
        value: function runServiceTests(mount, opts) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/tests",
                qs: _extends({}, opts, {
                    mount: mount
                })
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getServiceReadme",
        value: function getServiceReadme(mount) {
            return this._connection.request({
                path: "/_api/foxx/readme",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "getServiceDocumentation",
        value: function getServiceDocumentation(mount) {
            return this._connection.request({
                path: "/_api/foxx/swagger",
                qs: { mount: mount }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "downloadService",
        value: function downloadService(mount) {
            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/download",
                qs: { mount: mount },
                expectBinary: true
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "commitLocalServiceState",
        value: function commitLocalServiceState() {
            var replace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

            return this._connection.request({
                method: "POST",
                path: "/_api/foxx/commit",
                qs: { replace: replace }
            }, function () {
                return undefined;
            });
        }
    }, {
        key: "version",
        value: function version() {
            return this._connection.request({
                method: "GET",
                path: "/_api/version"
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "login",
        value: function login() {
            var _this7 = this;

            var username = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "root";
            var password = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            return this._connection.request({
                method: "POST",
                path: "/_open/auth",
                body: { username: username, password: password }
            }, function (res) {
                _this7.useBearerAuth(res.body.jwt);
                return res.body.jwt;
            });
        }
    }, {
        key: "name",
        get: function get() {
            return this._connection.getDatabaseName() || null;
        }
    }]);

    return Database;
}();

exports.Database = Database;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var querystring_1 = __webpack_require__(5);
var error_1 = __webpack_require__(0);
var bytelength_1 = __webpack_require__(19);
var request_1 = __webpack_require__(21);
var LinkedList = __webpack_require__(37);
var MIME_JSON = /\/(json|javascript)(\W|$)/;
var LEADER_ENDPOINT_HEADER = "x-arango-endpoint";
function isSystemError(err) {
    return Object.getPrototypeOf(err) === Error.prototype && err.hasOwnProperty("code") && err.hasOwnProperty("errno") && err.hasOwnProperty("syscall");
}

var Connection = function () {
    function Connection() {
        var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Connection);

        this._activeTasks = 0;
        this._arangoVersion = 30000;
        this._databaseName = "_system";
        this._queue = new LinkedList();
        this._hosts = [];
        this._urls = [];
        if (typeof config === "string") config = { url: config };else if (Array.isArray(config)) config = { url: config };
        if (config.arangoVersion !== undefined) {
            this._arangoVersion = config.arangoVersion;
        }
        if (config.isAbsolute) {
            this._databaseName = false;
        }
        this._agent = config.agent;
        this._agentOptions = request_1.isBrowser ? _extends({}, config.agentOptions) : _extends({
            maxSockets: 3,
            keepAlive: true,
            keepAliveMsecs: 1000
        }, config.agentOptions);
        this._maxTasks = this._agentOptions.maxSockets || 3;
        if (this._agentOptions.keepAlive) this._maxTasks *= 2;
        this._headers = _extends({}, config.headers);
        this._loadBalancingStrategy = config.loadBalancingStrategy || "NONE";
        this._useFailOver = this._loadBalancingStrategy !== "ROUND_ROBIN";
        if (config.maxRetries === false) {
            this._shouldRetry = false;
            this._maxRetries = 0;
        } else {
            this._shouldRetry = true;
            this._maxRetries = config.maxRetries || 0;
        }
        var urls = config.url ? Array.isArray(config.url) ? config.url : [config.url] : ["http://localhost:8529"];
        this.addToHostList(urls);
        if (this._loadBalancingStrategy === "ONE_RANDOM") {
            this._activeHost = Math.floor(Math.random() * this._hosts.length);
        } else {
            this._activeHost = 0;
        }
    }

    _createClass(Connection, [{
        key: "_runQueue",
        value: function _runQueue() {
            var _this = this;

            if (!this._queue.length || this._activeTasks >= this._maxTasks) return;
            var task = this._queue.shift();
            var host = this._activeHost;
            if (task.host !== undefined) {
                host = task.host;
            } else if (this._loadBalancingStrategy === "ROUND_ROBIN") {
                this._activeHost = (this._activeHost + 1) % this._hosts.length;
            }
            this._activeTasks += 1;
            this._hosts[host](task.options, function (err, res) {
                _this._activeTasks -= 1;
                if (err) {
                    if (_this._hosts.length > 1 && _this._activeHost === host && _this._useFailOver) {
                        _this._activeHost = (_this._activeHost + 1) % _this._hosts.length;
                    }
                    if (!task.host && _this._shouldRetry && task.retries < (_this._maxRetries || _this._hosts.length - 1) && isSystemError(err) && err.syscall === "connect" && err.code === "ECONNREFUSED") {
                        task.retries += 1;
                        _this._queue.push(task);
                    } else {
                        task.reject(err);
                    }
                } else {
                    var response = res;
                    if (response.statusCode === 503 && response.headers[LEADER_ENDPOINT_HEADER]) {
                        var url = response.headers[LEADER_ENDPOINT_HEADER];

                        var _addToHostList = _this.addToHostList(url),
                            _addToHostList2 = _slicedToArray(_addToHostList, 1),
                            index = _addToHostList2[0];

                        task.host = index;
                        if (_this._activeHost === host) {
                            _this._activeHost = index;
                        }
                        _this._queue.push(task);
                    } else {
                        response.host = host;
                        task.resolve(response);
                    }
                }
                _this._runQueue();
            });
        }
    }, {
        key: "_buildUrl",
        value: function _buildUrl(_ref) {
            var _ref$absolutePath = _ref.absolutePath,
                absolutePath = _ref$absolutePath === undefined ? false : _ref$absolutePath,
                basePath = _ref.basePath,
                path = _ref.path,
                qs = _ref.qs;

            var pathname = "";
            var search = void 0;
            if (!absolutePath) {
                pathname = this._databasePath;
                if (basePath) pathname += basePath;
            }
            if (path) pathname += path;
            if (qs) {
                if (typeof qs === "string") search = "?" + qs;else search = "?" + querystring_1.stringify(qs);
            }
            return search ? { pathname: pathname, search: search } : { pathname: pathname };
        }
    }, {
        key: "_sanitizeEndpointUrl",
        value: function _sanitizeEndpointUrl(url) {
            if (url.startsWith("tcp:")) return url.replace(/^tcp:/, "http:");
            if (url.startsWith("ssl:")) return url.replace(/^ssl:/, "https:");
            return url;
        }
    }, {
        key: "addToHostList",
        value: function addToHostList(urls) {
            var _this2 = this,
                _urls,
                _hosts;

            var cleanUrls = (Array.isArray(urls) ? urls : [urls]).map(function (url) {
                return _this2._sanitizeEndpointUrl(url);
            });
            var newUrls = cleanUrls.filter(function (url) {
                return _this2._urls.indexOf(url) === -1;
            });
            (_urls = this._urls).push.apply(_urls, _toConsumableArray(newUrls));
            (_hosts = this._hosts).push.apply(_hosts, _toConsumableArray(newUrls.map(function (url) {
                return request_1.createRequest(url, _this2._agentOptions, _this2._agent);
            })));
            return cleanUrls.map(function (url) {
                return _this2._urls.indexOf(url);
            });
        }
    }, {
        key: "getDatabaseName",
        value: function getDatabaseName() {
            return this._databaseName;
        }
    }, {
        key: "getActiveHost",
        value: function getActiveHost() {
            return this._activeHost;
        }
    }, {
        key: "setDatabaseName",
        value: function setDatabaseName(databaseName) {
            if (this._databaseName === false) {
                throw new Error("Can not change database from absolute URL");
            }
            this._databaseName = databaseName;
        }
    }, {
        key: "setHeader",
        value: function setHeader(key, value) {
            this._headers[key] = value;
        }
    }, {
        key: "close",
        value: function close() {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = this._hosts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var host = _step.value;

                    if (host.close) host.close();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }, {
        key: "request",
        value: function request(_ref2, getter) {
            var _this3 = this;

            var host = _ref2.host,
                _ref2$method = _ref2.method,
                method = _ref2$method === undefined ? "GET" : _ref2$method,
                body = _ref2.body,
                _ref2$expectBinary = _ref2.expectBinary,
                expectBinary = _ref2$expectBinary === undefined ? false : _ref2$expectBinary,
                _ref2$isBinary = _ref2.isBinary,
                isBinary = _ref2$isBinary === undefined ? false : _ref2$isBinary,
                _ref2$isJsonStream = _ref2.isJsonStream,
                isJsonStream = _ref2$isJsonStream === undefined ? false : _ref2$isJsonStream,
                headers = _ref2.headers,
                urlInfo = _objectWithoutProperties(_ref2, ["host", "method", "body", "expectBinary", "isBinary", "isJsonStream", "headers"]);

            return new Promise(function (_resolve, reject) {
                var contentType = "text/plain";
                if (isBinary) {
                    contentType = "application/octet-stream";
                } else if (body) {
                    if ((typeof body === "undefined" ? "undefined" : _typeof(body)) === "object") {
                        if (isJsonStream) {
                            body = body.map(function (obj) {
                                return JSON.stringify(obj);
                            }).join("\r\n") + "\r\n";
                            contentType = "application/x-ldjson";
                        } else {
                            body = JSON.stringify(body);
                            contentType = "application/json";
                        }
                    } else {
                        body = String(body);
                    }
                }
                var extraHeaders = _extends({}, _this3._headers, {
                    "content-type": contentType,
                    "x-arango-version": String(_this3._arangoVersion)
                });
                if (!request_1.isBrowser) {
                    // Node doesn't set content-length but ArangoDB needs it
                    extraHeaders["content-length"] = String(body ? bytelength_1.byteLength(body, "utf-8") : 0);
                }
                _this3._queue.push({
                    retries: 0,
                    host: host,
                    options: {
                        url: _this3._buildUrl(urlInfo),
                        headers: _extends({}, extraHeaders, headers),
                        method: method,
                        expectBinary: expectBinary,
                        body: body
                    },
                    reject: reject,
                    resolve: function resolve(res) {
                        var contentType = res.headers["content-type"];
                        var parsedBody = undefined;
                        if (res.body.length && contentType && contentType.match(MIME_JSON)) {
                            try {
                                parsedBody = res.body;
                                parsedBody = JSON.parse(parsedBody);
                            } catch (e) {
                                if (!expectBinary) {
                                    if (typeof parsedBody !== "string") {
                                        parsedBody = res.body.toString("utf-8");
                                    }
                                    e.response = res;
                                    reject(e);
                                    return;
                                }
                            }
                        } else if (res.body && !expectBinary) {
                            parsedBody = res.body.toString("utf-8");
                        } else {
                            parsedBody = res.body;
                        }
                        if (parsedBody && parsedBody.hasOwnProperty("error") && parsedBody.hasOwnProperty("code") && parsedBody.hasOwnProperty("errorMessage") && parsedBody.hasOwnProperty("errorNum")) {
                            res.body = parsedBody;
                            reject(new error_1.ArangoError(res));
                        } else if (res.statusCode && res.statusCode >= 400) {
                            res.body = parsedBody;
                            reject(new error_1.HttpError(res));
                        } else {
                            if (!expectBinary) res.body = parsedBody;
                            _resolve(getter ? getter(res) : res);
                        }
                    }
                });
                _this3._runQueue();
            });
        }
    }, {
        key: "_databasePath",
        get: function get() {
            return this._databaseName === false ? "" : "/_db/" + this._databaseName;
        }
    }, {
        key: "arangoMajor",
        get: function get() {
            return Math.floor(this._arangoVersion / 10000);
        }
    }]);

    return Connection;
}();

exports.Connection = Connection;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var stringifyPrimitive = function stringifyPrimitive(v) {
  switch (typeof v === 'undefined' ? 'undefined' : _typeof(v)) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.byteLength = __webpack_require__(20);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (s) {
  return ~-encodeURI(s).split(/%..|./).length;
};

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

Object.defineProperty(exports, "__esModule", { value: true });
var url_1 = __webpack_require__(22);
var joinPath_1 = __webpack_require__(25);
var xhr_1 = __webpack_require__(28);
exports.isBrowser = true;
function omit(obj, keys) {
    var result = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = Object.keys(obj)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var key = _step.value;

            if (keys.includes(key)) continue;
            result[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return result;
}
function createRequest(baseUrl, agentOptions) {
    var baseUrlParts = url_1.parse(baseUrl);
    var options = omit(agentOptions, ["keepAlive", "keepAliveMsecs", "maxSockets"]);
    return function request(_ref, cb) {
        var method = _ref.method,
            url = _ref.url,
            headers = _ref.headers,
            body = _ref.body,
            expectBinary = _ref.expectBinary;

        var urlParts = _extends({}, baseUrlParts, {
            pathname: url.pathname ? baseUrlParts.pathname ? joinPath_1.joinPath(baseUrlParts.pathname, url.pathname) : url.pathname : baseUrlParts.pathname,
            search: url.search ? baseUrlParts.search ? baseUrlParts.search + "&" + url.search.slice(1) : url.search : baseUrlParts.search
        });
        var _callback = function callback(err, res) {
            _callback = function callback() {
                return undefined;
            };
            cb(err, res);
        };
        var req = xhr_1.default(_extends({
            responseType: expectBinary ? "blob" : "text"
        }, options, {
            url: url_1.format(urlParts),
            withCredentials: true,
            useXDR: true,
            body: body,
            method: method,
            headers: headers
        }), function (err, res) {
            if (!err) {
                if (!res.body) res.body = "";
                _callback(null, res);
            } else {
                var error = err;
                error.request = req;
                _callback(error);
            }
        });
    };
}
exports.createRequest = createRequest;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var punycode = __webpack_require__(23);
var util = __webpack_require__(24);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,


// Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,


// RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],


// RFC 2396: characters not allowed for various reasons.
unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),


// Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = ['\''].concat(unwise),

// Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,

// protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that never have a hostname.
hostlessProtocol = {
  'javascript': true,
  'javascript:': true
},

// protocols that always contain a // bit.
slashedProtocol = {
  'http': true,
  'https': true,
  'ftp': true,
  'gopher': true,
  'file': true,
  'http:': true,
  'https:': true,
  'ftp:': true,
  'gopher:': true,
  'file:': true
},
    querystring = __webpack_require__(5);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === 'undefined' ? 'undefined' : _typeof(url)));
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && util.isObject(this.query) && Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || query && '?' + query || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) {}
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
      isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
      mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname,
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && srcPath.join('/').substr(-1) !== '/') {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || srcPath[0] && srcPath[0].charAt(0) === '/';

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || result.host && srcPath.length;

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function (root) {

	/** Detect free variables */
	var freeExports = ( false ? 'undefined' : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;
	var freeModule = ( false ? 'undefined' : _typeof(module)) == 'object' && module && !module.nodeType && module;
	var freeGlobal = (typeof global === 'undefined' ? 'undefined' : _typeof(global)) == 'object' && global;
	if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) {
		root = freeGlobal;
	}

	/**
  * The `punycode` object.
  * @name punycode
  * @type Object
  */
	var punycode,


	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647,
	    // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	    tMin = 1,
	    tMax = 26,
	    skew = 38,
	    damp = 700,
	    initialBias = 72,
	    initialN = 128,
	    // 0x80
	delimiter = '-',
	    // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	    regexNonASCII = /[^\x20-\x7E]/,
	    // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g,
	    // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},


	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	    floor = Math.floor,
	    stringFromCharCode = String.fromCharCode,


	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
  * A generic error utility function.
  * @private
  * @param {String} type The error type.
  * @returns {Error} Throws a `RangeError` with the applicable error message.
  */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
  * A generic `Array#map` utility function.
  * @private
  * @param {Array} array The array to iterate over.
  * @param {Function} callback The function that gets called for every array
  * item.
  * @returns {Array} A new array of values returned by the callback function.
  */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
  * A simple `Array#map`-like wrapper to work with domain name strings or email
  * addresses.
  * @private
  * @param {String} domain The domain name or email address.
  * @param {Function} callback The function that gets called for every
  * character.
  * @returns {Array} A new string of characters returned by the callback
  * function.
  */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
  * Creates an array containing the numeric code points of each Unicode
  * character in the string. While JavaScript uses UCS-2 internally,
  * this function will convert a pair of surrogate halves (each of which
  * UCS-2 exposes as separate characters) into a single code point,
  * matching UTF-16.
  * @see `punycode.ucs2.encode`
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode.ucs2
  * @name decode
  * @param {String} string The Unicode input string (UCS-2).
  * @returns {Array} The new array of code points.
  */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) {
					// low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
  * Creates a string based on an array of numeric code points.
  * @see `punycode.ucs2.decode`
  * @memberOf punycode.ucs2
  * @name encode
  * @param {Array} codePoints The array of numeric code points.
  * @returns {String} The new Unicode string (UCS-2).
  */
	function ucs2encode(array) {
		return map(array, function (value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
  * Converts a basic code point into a digit/integer.
  * @see `digitToBasic()`
  * @private
  * @param {Number} codePoint The basic numeric code point value.
  * @returns {Number} The numeric value of a basic code point (for use in
  * representing integers) in the range `0` to `base - 1`, or `base` if
  * the code point does not represent a value.
  */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
  * Converts a digit/integer into a basic code point.
  * @see `basicToDigit()`
  * @private
  * @param {Number} digit The numeric value of a basic code point.
  * @returns {Number} The basic code point whose value (when used for
  * representing integers) is `digit`, which needs to be in the range
  * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
  * used; else, the lowercase form is used. The behavior is undefined
  * if `flag` is non-zero and `digit` has no uppercase form.
  */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
  * Bias adaptation function as per section 3.4 of RFC 3492.
  * https://tools.ietf.org/html/rfc3492#section-3.4
  * @private
  */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (; /* no initialization */delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
  * Converts a Punycode string of ASCII-only symbols to a string of Unicode
  * symbols.
  * @memberOf punycode
  * @param {String} input The Punycode string of ASCII-only symbols.
  * @returns {String} The resulting string of Unicode symbols.
  */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,

		/** Cached calculation results */
		baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength;) /* no final expression */{

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base;; /* no condition */k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;
			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);
		}

		return ucs2encode(output);
	}

	/**
  * Converts a string of Unicode symbols (e.g. a domain name label) to a
  * Punycode string of ASCII-only symbols.
  * @memberOf punycode
  * @param {String} input The string of Unicode symbols.
  * @returns {String} The resulting Punycode string of ASCII-only symbols.
  */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],

		/** `inputLength` will hold the number of code points in `input`. */
		inputLength,

		/** Cached calculation results */
		handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base;; /* no condition */k += base) {
						t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;
		}
		return output.join('');
	}

	/**
  * Converts a Punycode string representing a domain name or an email address
  * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
  * it doesn't matter if you call it on a string that has already been
  * converted to Unicode.
  * @memberOf punycode
  * @param {String} input The Punycoded domain name or email address to
  * convert to Unicode.
  * @returns {String} The Unicode representation of the given Punycode
  * string.
  */
	function toUnicode(input) {
		return mapDomain(input, function (string) {
			return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
		});
	}

	/**
  * Converts a Unicode string representing a domain name or an email address to
  * Punycode. Only the non-ASCII parts of the domain name will be converted,
  * i.e. it doesn't matter if you call it with a domain that's already in
  * ASCII.
  * @memberOf punycode
  * @param {String} input The domain name or email address to convert, as a
  * Unicode string.
  * @returns {String} The Punycode representation of the given domain name or
  * email address.
  */
	function toASCII(input) {
		return mapDomain(input, function (string) {
			return regexNonASCII.test(string) ? 'xn--' + encode(string) : string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
   * A string representing the current Punycode.js version number.
   * @memberOf punycode
   * @type String
   */
		'version': '1.4.1',
		/**
   * An object of methods to convert from JavaScript's internal character
   * representation (UCS-2) to Unicode code points, and back.
   * @see <https://mathiasbynens.be/notes/javascript-encoding>
   * @memberOf punycode
   * @type Object
   */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if ("function" == 'function' && _typeof(__webpack_require__(7)) == 'object' && __webpack_require__(7)) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}
})(undefined);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)(module), __webpack_require__(6)))

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

module.exports = {
  isString: function isString(arg) {
    return typeof arg === 'string';
  },
  isObject: function isObject(arg) {
    return (typeof arg === 'undefined' ? 'undefined' : _typeof(arg)) === 'object' && arg !== null;
  },
  isNull: function isNull(arg) {
    return arg === null;
  },
  isNullOrUndefined: function isNullOrUndefined(arg) {
    return arg == null;
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
var path_1 = __webpack_require__(26);
exports.joinPath = path_1.join;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
var splitPath = function splitPath(filename) {
  return splitPathRe.exec(filename).slice(1);
};

// path.resolve([from ...], to)
// posix version
exports.resolve = function () {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = i >= 0 ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function (p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function (path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function (p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function (path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function () {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function (p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};

// path.relative(from, to)
// posix version
exports.relative = function (from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  var result = splitPath(path),
      root = result[0],
      dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
};

exports.basename = function (path, ext) {
  var f = splitPath(path)[2];
  // TODO: make this comparison case-insensitive on windows?
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  return splitPath(path)[3];
};

function filter(xs, f) {
  if (xs.filter) return xs.filter(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    if (f(xs[i], i, xs)) res.push(xs[i]);
  }
  return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b' ? function (str, start, len) {
  return str.substr(start, len);
} : function (str, start, len) {
  if (start < 0) start = str.length + start;
  return str.substr(start, len);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
exports.default = __webpack_require__(29);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var window = __webpack_require__(30);
var isFunction = __webpack_require__(31);
var parseHeaders = __webpack_require__(32);
var xtend = __webpack_require__(36);

module.exports = createXHR;
// Allow use of default import syntax in TypeScript
module.exports.default = createXHR;
createXHR.XMLHttpRequest = window.XMLHttpRequest || noop;
createXHR.XDomainRequest = "withCredentials" in new createXHR.XMLHttpRequest() ? createXHR.XMLHttpRequest : window.XDomainRequest;

forEachArray(["get", "put", "post", "patch", "head", "delete"], function (method) {
    createXHR[method === "delete" ? "del" : method] = function (uri, options, callback) {
        options = initParams(uri, options, callback);
        options.method = method.toUpperCase();
        return _createXHR(options);
    };
});

function forEachArray(array, iterator) {
    for (var i = 0; i < array.length; i++) {
        iterator(array[i]);
    }
}

function isEmpty(obj) {
    for (var i in obj) {
        if (obj.hasOwnProperty(i)) return false;
    }
    return true;
}

function initParams(uri, options, callback) {
    var params = uri;

    if (isFunction(options)) {
        callback = options;
        if (typeof uri === "string") {
            params = { uri: uri };
        }
    } else {
        params = xtend(options, { uri: uri });
    }

    params.callback = callback;
    return params;
}

function createXHR(uri, options, callback) {
    options = initParams(uri, options, callback);
    return _createXHR(options);
}

function _createXHR(options) {
    if (typeof options.callback === "undefined") {
        throw new Error("callback argument missing");
    }

    var called = false;
    var callback = function cbOnce(err, response, body) {
        if (!called) {
            called = true;
            options.callback(err, response, body);
        }
    };

    function readystatechange() {
        if (xhr.readyState === 4) {
            setTimeout(loadFunc, 0);
        }
    }

    function getBody() {
        // Chrome with requestType=blob throws errors arround when even testing access to responseText
        var body = undefined;

        if (xhr.response) {
            body = xhr.response;
        } else {
            body = xhr.responseText || getXml(xhr);
        }

        if (isJson) {
            try {
                body = JSON.parse(body);
            } catch (e) {}
        }

        return body;
    }

    function errorFunc(evt) {
        clearTimeout(timeoutTimer);
        if (!(evt instanceof Error)) {
            evt = new Error("" + (evt || "Unknown XMLHttpRequest Error"));
        }
        evt.statusCode = 0;
        return callback(evt, failureResponse);
    }

    // will load the data & process the response in a special response object
    function loadFunc() {
        if (aborted) return;
        var status;
        clearTimeout(timeoutTimer);
        if (options.useXDR && xhr.status === undefined) {
            //IE8 CORS GET successful response doesn't have a status field, but body is fine
            status = 200;
        } else {
            status = xhr.status === 1223 ? 204 : xhr.status;
        }
        var response = failureResponse;
        var err = null;

        if (status !== 0) {
            response = {
                body: getBody(),
                statusCode: status,
                method: method,
                headers: {},
                url: uri,
                rawRequest: xhr
            };
            if (xhr.getAllResponseHeaders) {
                //remember xhr can in fact be XDR for CORS in IE
                response.headers = parseHeaders(xhr.getAllResponseHeaders());
            }
        } else {
            err = new Error("Internal XMLHttpRequest Error");
        }
        return callback(err, response, response.body);
    }

    var xhr = options.xhr || null;

    if (!xhr) {
        if (options.cors || options.useXDR) {
            xhr = new createXHR.XDomainRequest();
        } else {
            xhr = new createXHR.XMLHttpRequest();
        }
    }

    var key;
    var aborted;
    var uri = xhr.url = options.uri || options.url;
    var method = xhr.method = options.method || "GET";
    var body = options.body || options.data;
    var headers = xhr.headers = options.headers || {};
    var sync = !!options.sync;
    var isJson = false;
    var timeoutTimer;
    var failureResponse = {
        body: undefined,
        headers: {},
        statusCode: 0,
        method: method,
        url: uri,
        rawRequest: xhr
    };

    if ("json" in options && options.json !== false) {
        isJson = true;
        headers["accept"] || headers["Accept"] || (headers["Accept"] = "application/json"); //Don't override existing accept header declared by user
        if (method !== "GET" && method !== "HEAD") {
            headers["content-type"] || headers["Content-Type"] || (headers["Content-Type"] = "application/json"); //Don't override existing accept header declared by user
            body = JSON.stringify(options.json === true ? body : options.json);
        }
    }

    xhr.onreadystatechange = readystatechange;
    xhr.onload = loadFunc;
    xhr.onerror = errorFunc;
    // IE9 must have onprogress be set to a unique function.
    xhr.onprogress = function () {
        // IE must die
    };
    xhr.onabort = function () {
        aborted = true;
    };
    xhr.ontimeout = errorFunc;
    xhr.open(method, uri, !sync, options.username, options.password);
    //has to be after open
    if (!sync) {
        xhr.withCredentials = !!options.withCredentials;
    }
    // Cannot set timeout with sync request
    // not setting timeout on the xhr object, because of old webkits etc. not handling that correctly
    // both npm's request and jquery 1.x use this kind of timeout, so this is being consistent
    if (!sync && options.timeout > 0) {
        timeoutTimer = setTimeout(function () {
            if (aborted) return;
            aborted = true; //IE9 may still call readystatechange
            xhr.abort("timeout");
            var e = new Error("XMLHttpRequest timeout");
            e.code = "ETIMEDOUT";
            errorFunc(e);
        }, options.timeout);
    }

    if (xhr.setRequestHeader) {
        for (key in headers) {
            if (headers.hasOwnProperty(key)) {
                xhr.setRequestHeader(key, headers[key]);
            }
        }
    } else if (options.headers && !isEmpty(options.headers)) {
        throw new Error("Headers cannot be set on an XDomainRequest object");
    }

    if ("responseType" in options) {
        xhr.responseType = options.responseType;
    }

    if ("beforeSend" in options && typeof options.beforeSend === "function") {
        options.beforeSend(xhr);
    }

    // Microsoft Edge browser sends "undefined" when send is called with undefined value.
    // XMLHttpRequest spec says to pass null as body to indicate no body
    // See https://github.com/naugtur/xhr/issues/100.
    xhr.send(body || null);

    return xhr;
}

function getXml(xhr) {
    // xhr.responseXML will throw Exception "InvalidStateError" or "DOMException"
    // See https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/responseXML.
    try {
        if (xhr.responseType === "document") {
            return xhr.responseXML;
        }
        var firefoxBugTakenEffect = xhr.responseXML && xhr.responseXML.documentElement.nodeName === "parsererror";
        if (xhr.responseType === "" && !firefoxBugTakenEffect) {
            return xhr.responseXML;
        }
    } catch (e) {}

    return null;
}

function noop() {}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined") {
    win = self;
} else {
    win = {};
}

module.exports = win;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = isFunction;

var toString = Object.prototype.toString;

function isFunction(fn) {
  var string = toString.call(fn);
  return string === '[object Function]' || typeof fn === 'function' && string !== '[object RegExp]' || typeof window !== 'undefined' && (
  // IE8 and below
  fn === window.setTimeout || fn === window.alert || fn === window.confirm || fn === window.prompt);
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var trim = __webpack_require__(33),
    forEach = __webpack_require__(34),
    isArray = function isArray(arg) {
  return Object.prototype.toString.call(arg) === '[object Array]';
};

module.exports = function (headers) {
  if (!headers) return {};

  var result = {};

  forEach(trim(headers).split('\n'), function (row) {
    var index = row.indexOf(':'),
        key = trim(row.slice(0, index)).toLowerCase(),
        value = trim(row.slice(index + 1));

    if (typeof result[key] === 'undefined') {
      result[key] = value;
    } else if (isArray(result[key])) {
      result[key].push(value);
    } else {
      result[key] = [result[key], value];
    }
  });

  return result;
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = trim;

function trim(str) {
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function (str) {
  return str.replace(/^\s*/, '');
};

exports.right = function (str) {
  return str.replace(/\s*$/, '');
};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isCallable = __webpack_require__(35);

var toStr = Object.prototype.toString;
var hasOwnProperty = Object.prototype.hasOwnProperty;

var forEachArray = function forEachArray(array, iterator, receiver) {
    for (var i = 0, len = array.length; i < len; i++) {
        if (hasOwnProperty.call(array, i)) {
            if (receiver == null) {
                iterator(array[i], i, array);
            } else {
                iterator.call(receiver, array[i], i, array);
            }
        }
    }
};

var forEachString = function forEachString(string, iterator, receiver) {
    for (var i = 0, len = string.length; i < len; i++) {
        // no such thing as a sparse string.
        if (receiver == null) {
            iterator(string.charAt(i), i, string);
        } else {
            iterator.call(receiver, string.charAt(i), i, string);
        }
    }
};

var forEachObject = function forEachObject(object, iterator, receiver) {
    for (var k in object) {
        if (hasOwnProperty.call(object, k)) {
            if (receiver == null) {
                iterator(object[k], k, object);
            } else {
                iterator.call(receiver, object[k], k, object);
            }
        }
    }
};

var forEach = function forEach(list, iterator, thisArg) {
    if (!isCallable(iterator)) {
        throw new TypeError('iterator must be a function');
    }

    var receiver;
    if (arguments.length >= 3) {
        receiver = thisArg;
    }

    if (toStr.call(list) === '[object Array]') {
        forEachArray(list, iterator, receiver);
    } else if (typeof list === 'string') {
        forEachString(list, iterator, receiver);
    } else {
        forEachObject(list, iterator, receiver);
    }
};

module.exports = forEach;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var fnToStr = Function.prototype.toString;

var constructorRegex = /^\s*class /;
var isES6ClassFn = function isES6ClassFn(value) {
	try {
		var fnStr = fnToStr.call(value);
		var singleStripped = fnStr.replace(/\/\/.*\n/g, '');
		var multiStripped = singleStripped.replace(/\/\*[.\s\S]*\*\//g, '');
		var spaceStripped = multiStripped.replace(/\n/mg, ' ').replace(/ {2}/g, ' ');
		return constructorRegex.test(spaceStripped);
	} catch (e) {
		return false; // not a function
	}
};

var tryFunctionObject = function tryFunctionObject(value) {
	try {
		if (isES6ClassFn(value)) {
			return false;
		}
		fnToStr.call(value);
		return true;
	} catch (e) {
		return false;
	}
};
var toStr = Object.prototype.toString;
var fnClass = '[object Function]';
var genClass = '[object GeneratorFunction]';
var hasToStringTag = typeof Symbol === 'function' && _typeof(Symbol.toStringTag) === 'symbol';

module.exports = function isCallable(value) {
	if (!value) {
		return false;
	}
	if (typeof value !== 'function' && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') {
		return false;
	}
	if (hasToStringTag) {
		return tryFunctionObject(value);
	}
	if (isES6ClassFn(value)) {
		return false;
	}
	var strClass = toStr.call(value);
	return strClass === fnClass || strClass === genClass;
};

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = extend;

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
  Object.defineProperty(this, '_head', {
    value: undefined,
    writable: true,
    enumerable: false,
    configurable: false
  });
  Object.defineProperty(this, '_tail', {
    value: undefined,
    writable: true,
    enumerable: false,
    configurable: false
  });
  Object.defineProperty(this, '_next', {
    value: undefined,
    writable: true,
    enumerable: false,
    configurable: false
  });
  Object.defineProperty(this, '_length', {
    value: 0,
    writable: true,
    enumerable: false,
    configurable: false
  });
};

module.exports.prototype.__defineGetter__('head', function () {
  return this._head && this._head.data;
});

module.exports.prototype.__defineGetter__('tail', function () {
  return this._tail && this._tail.data;
});

module.exports.prototype.__defineGetter__('current', function () {
  return this._current && this._current.data;
});

module.exports.prototype.__defineGetter__('length', function () {
  return this._length;
});

module.exports.prototype.push = function (data) {
  this._tail = new Item(data, this._tail);
  if (this._length === 0) {
    this._head = this._tail;
    this._current = this._head;
    this._next = this._head;
  }
  this._length++;
};

module.exports.prototype.pop = function () {
  var tail = this._tail;
  if (this._length === 0) {
    return;
  }
  this._length--;
  if (this._length === 0) {
    this._head = this._tail = this._current = this._next = undefined;
    return tail.data;
  }
  this._tail = tail.prev;
  this._tail.next = undefined;
  if (this._current === tail) {
    this._current = this._tail;
    this._next = undefined;
  }
  return tail.data;
};

module.exports.prototype.shift = function () {
  var head = this._head;
  if (this._length === 0) {
    return;
  }
  this._length--;
  if (this._length === 0) {
    this._head = this._tail = this._current = this._next = undefined;
    return head.data;
  }
  this._head = this._head.next;
  if (this._current === head) {
    this._current = this._head;
    this._next = this._current.next;
  }
  return head.data;
};

module.exports.prototype.unshift = function (data) {
  this._head = new Item(data, undefined, this._head);
  if (this._length === 0) {
    this._tail = this._head;
    this._next = this._head;
  }
  this._length++;
};

module.exports.prototype.unshiftCurrent = function () {
  var current = this._current;
  if (current === this._head || this._length < 2) {
    return current && current.data;
  }
  // remove
  if (current === this._tail) {
    this._tail = current.prev;
    this._tail.next = undefined;
    this._current = this._tail;
  } else {
    current.next.prev = current.prev;
    current.prev.next = current.next;
    this._current = current.prev;
  }
  this._next = this._current.next;
  // unshift
  current.next = this._head;
  current.prev = undefined;
  this._head.prev = current;
  this._head = current;
  return current.data;
};

module.exports.prototype.removeCurrent = function (data) {
  var current = this._current;
  if (this._length === 0) {
    return;
  }
  this._length--;
  if (this._length === 0) {
    this._head = this._tail = this._current = this._next = undefined;
    return current.data;
  }
  if (current === this._tail) {
    this._tail = current.prev;
    this._tail.next = undefined;
    this._current = this._tail;
  } else if (current === this._head) {
    this._head = current.next;
    this._head.prev = undefined;
    this._current = this._head;
  } else {
    current.next.prev = current.prev;
    current.prev.next = current.next;
    this._current = current.prev;
  }
  this._next = this._current.next;
  return current.data;
};

module.exports.prototype.next = function () {
  var next = this._next;
  if (next !== undefined) {
    this._next = next.next;
    this._current = next;
    return next.data;
  }
};

module.exports.prototype.resetCursor = function () {
  this._current = this._next = this._head;
  return this;
};

function Item(data, prev, next) {
  this.next = next;
  if (next) next.prev = this;
  this.prev = prev;
  if (prev) prev.next = this;
  this.data = data;
}

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });

var Route = function () {
    function Route(connection) {
        var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
        var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

        _classCallCheck(this, Route);

        if (!path) path = "";else if (path.charAt(0) !== "/") path = "/" + path;
        this._connection = connection;
        this._path = path;
        this._headers = headers;
    }

    _createClass(Route, [{
        key: "route",
        value: function route(path, headers) {
            if (!path) path = "";else if (path.charAt(0) !== "/") path = "/" + path;
            return new Route(this._connection, this._path + path, _extends({}, this._headers, headers));
        }
    }, {
        key: "request",
        value: function request(_ref) {
            var method = _ref.method,
                path = _ref.path,
                _ref$headers = _ref.headers,
                headers = _ref$headers === undefined ? {} : _ref$headers,
                opts = _objectWithoutProperties(_ref, ["method", "path", "headers"]);

            if (!path) opts.path = "";else if (this._path && path.charAt(0) !== "/") opts.path = "/" + path;else opts.path = path;
            opts.basePath = this._path;
            opts.headers = _extends({}, this._headers, headers);
            opts.method = method ? method.toUpperCase() : "GET";
            return this._connection.request(opts);
        }
    }, {
        key: "_request1",
        value: function _request1(method) {
            var path = "";
            var qs = void 0;
            var headers = void 0;

            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            if (args[0] === undefined || typeof args[0] === "string") {
                path = args.shift();
            }
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                qs = args.shift();
            }
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                headers = args.shift();
            }
            return this.request({ method: method, path: path, qs: qs, headers: headers });
        }
    }, {
        key: "_request2",
        value: function _request2(method) {
            var path = "";
            var body = undefined;
            var qs = void 0;
            var headers = void 0;

            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                args[_key2 - 1] = arguments[_key2];
            }

            if (args[0] === undefined || typeof args[0] === "string") {
                path = args.shift();
            }
            body = args.shift();
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                qs = args.shift();
            }
            if (args[0] === undefined || _typeof(args[0]) === "object") {
                headers = args.shift();
            }
            return this.request({ method: method, path: path, body: body, qs: qs, headers: headers });
        }
    }, {
        key: "delete",
        value: function _delete() {
            for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            return this._request1.apply(this, ["DELETE"].concat(args));
        }
    }, {
        key: "get",
        value: function get() {
            for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
            }

            return this._request1.apply(this, ["GET"].concat(args));
        }
    }, {
        key: "head",
        value: function head() {
            for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            return this._request1.apply(this, ["HEAD"].concat(args));
        }
    }, {
        key: "patch",
        value: function patch() {
            for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                args[_key6] = arguments[_key6];
            }

            return this._request2.apply(this, ["PATCH"].concat(args));
        }
    }, {
        key: "post",
        value: function post() {
            for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                args[_key7] = arguments[_key7];
            }

            return this._request2.apply(this, ["POST"].concat(args));
        }
    }, {
        key: "put",
        value: function put() {
            for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                args[_key8] = arguments[_key8];
            }

            return this._request2.apply(this, ["PUT"].concat(args));
        }
    }]);

    return Route;
}();

exports.Route = Route;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", { value: true });
function btoa(str) {
    return window.btoa(str);
}
exports.btoa = btoa;

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

Object.defineProperty(exports, "__esModule", { value: true });
function toForm(fields, callback) {
    var form = void 0;
    try {
        form = new FormData();
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = Object.keys(fields)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var key = _step.value;

                var value = fields[key];
                if (value === undefined) continue;
                if (!(value instanceof Blob) && ((typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" || typeof value === "function")) {
                    value = JSON.stringify(value);
                }
                form.append(key, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } catch (e) {
        callback(e);
        return;
    }
    callback(null, { body: form });
}
exports.toForm = toForm;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", { value: true });
var error_1 = __webpack_require__(0);
var ViewType;
(function (ViewType) {
    ViewType["ARANGOSEARCH_VIEW"] = "arangosearch";
})(ViewType = exports.ViewType || (exports.ViewType = {}));
var VIEW_NOT_FOUND = 1203;

var BaseView = function () {
    function BaseView(connection, name) {
        _classCallCheck(this, BaseView);

        this.isArangoView = true;
        this.name = name;
        this._connection = connection;
    }

    _createClass(BaseView, [{
        key: "get",
        value: function get() {
            return this._connection.request({ path: "/_api/view/" + this.name }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "exists",
        value: function exists() {
            return this.get().then(function () {
                return true;
            }, function (err) {
                if (error_1.isArangoError(err) && err.errorNum === VIEW_NOT_FOUND) {
                    return false;
                }
                throw err;
            });
        }
    }, {
        key: "rename",
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(name) {
                var result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return this._connection.request({
                                    method: "PUT",
                                    path: "/_api/view/" + this.name + "/rename",
                                    body: { name: name }
                                }, function (res) {
                                    return res.body;
                                });

                            case 2:
                                result = _context.sent;

                                this.name = name;
                                return _context.abrupt("return", result);

                            case 5:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function rename(_x) {
                return _ref.apply(this, arguments);
            }

            return rename;
        }()
    }, {
        key: "drop",
        value: function drop() {
            return this._connection.request({
                method: "DELETE",
                path: "/_api/view/" + this.name
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return BaseView;
}();

exports.BaseView = BaseView;

var ArangoSearchView = function (_BaseView) {
    _inherits(ArangoSearchView, _BaseView);

    function ArangoSearchView() {
        _classCallCheck(this, ArangoSearchView);

        var _this = _possibleConstructorReturn(this, (ArangoSearchView.__proto__ || Object.getPrototypeOf(ArangoSearchView)).apply(this, arguments));

        _this.type = ViewType.ARANGOSEARCH_VIEW;
        return _this;
    }

    _createClass(ArangoSearchView, [{
        key: "create",
        value: function create() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._connection.request({
                method: "POST",
                path: "/_api/view",
                body: {
                    properties: properties,
                    name: this.name,
                    type: this.type
                }
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "properties",
        value: function properties() {
            return this._connection.request({ path: "/_api/view/" + this.name + "/properties" }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "setProperties",
        value: function setProperties() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._connection.request({
                method: "PATCH",
                path: "/_api/view/" + this.name + "/properties",
                body: properties
            }, function (res) {
                return res.body;
            });
        }
    }, {
        key: "replaceProperties",
        value: function replaceProperties() {
            var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            return this._connection.request({
                method: "PUT",
                path: "/_api/view/" + this.name + "/properties",
                body: properties
            }, function (res) {
                return res.body;
            });
        }
    }]);

    return ArangoSearchView;
}(BaseView);

exports.ArangoSearchView = ArangoSearchView;
function constructView(connection, data) {
    if (data.type && data.type !== ViewType.ARANGOSEARCH_VIEW) {
        throw new Error("Unknown view type \"" + data.type + "\"");
    }
    return new ArangoSearchView(connection, data.name);
}
exports.constructView = constructView;

/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// web.js